let unauthorizedHandler = null

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler
}

function shouldNotifyUnauthorized(url, status) {
  if (status !== 401) return false
  const path = String(url)
  return !path.includes('/api/auth/login') && !path.includes('/api/auth/me')
}

export async function request(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  })
  const data = await res.json().catch(() => ({}))
  if (shouldNotifyUnauthorized(url, res.status)) {
    unauthorizedHandler?.()
  }
  if (!res.ok) {
    const err = new Error(data.error || `请求失败 (${res.status})`)
    err.status = res.status
    throw err
  }
  return data
}

export async function fetchWithCredentials(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    ...options,
  })
  const data = await res.json().catch(() => ({}))
  if (shouldNotifyUnauthorized(url, res.status)) {
    unauthorizedHandler?.()
  }
  return { res, data }
}
